module.exports = __webpack_public_path__ + "static/media/css3.15678ffe.svg";